import type { TagProps } from '@chakra-ui/react';
import React from 'react';

export type Tags = string[];

export interface TagSelectProps {
  children?: TagSelectChildren;
  maxCharacters?: number;
  onChange: (tags: Tags) => void;
  prefix?: string;
  suffix?: string;
  tagProps?: TagProps;
  tags: Tags;
  textInputPlaceholder?: string;
  textSubmitButton?: string;
}
export interface TagSelectChildFnArgs {
  addTags: (tags: Tags) => void;
  handleAdd: (tag: string) => void;
  handleChange: (event: React.FormEvent<HTMLInputElement>) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  handleRemove: (tag: string) => void;
  handleSubmit: () => void;
  maxCharacters: number;
  removeTags: (tags: Tags) => void;
  renderUI: () => React.ReactElement;
  setTags: (tags: string[]) => void;
  setValue: (value: string) => void;
  tags: Tags;
  value: string;
}

export type TagSelectChildFn = (args: TagSelectChildFnArgs) => React.ReactNode;

export type TagSelectChildren = TagSelectChildFn | React.ReactNode;
